import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionEventInfoRequest } from "../../info/event/actionEventInfo";
import { actionModalCloseAll, actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionThemedEventFinishResponse, actionThemedEventLoadBuilding, TypeActionThemedEvent, } from "../actionThemedEvent";
export var epicThemedEventFinish = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionThemedEvent.FinishRequest), switchMap(function (action) {
        var playerId = selectPlayerInfo(state$.value).playerId;
        return deps
            .netSend({
            id: CommandCode.ThemedEventFinish,
            props: {
                eventId: action.eventId,
                playerId: playerId,
            },
        })
            .pipe(switchMap(function (res) {
            return from([
                actionThemedEventFinishResponse(action.eventId),
                actionEventInfoRequest(),
                actionThemedEventLoadBuilding(),
                actionModalCloseAll(),
                actionModalOpen(IdModal.ThemedEventReward),
            ]);
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/epics/epicThemedEventFinish.ts
// module id = 2423
// module chunks = 3